import { db_PrivateKeyPair, db_ExtPub, BASEURL } from "./AppState.js";

export async function generate_key(name, email, comment, passphrase) {

    const key = await openpgp.generateKey({
        type: 'ecc', // Type of the key, defaults to ECC
        curve: 'curve25519', // ECC curve name, defaults to curve25519
        userIDs: [{ name, email, comment }], // you can pass multiple user IDs
        passphrase, // protects the private key
        format: 'armored' // output key format, defaults to 'armored' (other options: 'binary' or 'object')
    });

    key.passphrase = passphrase

    await db_PrivateKeyPair.set('keyPair', key);

    const mykey = await get_pub_key();

    await add_pub_key(mykey.myKeyPairPublicKey);

    return true

}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export const encrypt_gpg = async (plain_text, oneclick_secret_PSK, public_key) => {

    const message = await openpgp.createMessage({ text: plain_text });

    const enc_options = {
        message, // input as Message object
        // signingKeys: decryptedPrivKey, // Only if there is a PrivateKey in the DB
        //format: 'binary' // don't ASCII armor (for Uint8Array output)
    }

    const keyPair = await db_PrivateKeyPair.get('keyPair');

    if (keyPair != null) {

        const decryptedPrivKey = await openpgp.decryptKey({ // get the private key for signature purpose
            privateKey: await openpgp.readPrivateKey({ armoredKey: keyPair.privateKey }),
            passphrase: keyPair.passphrase
        })
        enc_options.signingKeys = decryptedPrivKey // sign with the decrypted private key
    }

    if (oneclick_secret_PSK && public_key.length > 0) {
        console.log("both pass and key. Cannot encrypt.")
        return update_armoured_text("")
    }

    if (oneclick_secret_PSK) {
        enc_options.passwords = [oneclick_secret_PSK] // multiple passwords possible, however not needed in this use case
    } else if (public_key) {
        const pk_array = []
        for (const pk in public_key) {
            const key = await openpgp.readKey({ armoredKey: public_key[pk] })
            pk_array.push(key)
        }
        // const publicKey = await openpgp.readKey({ armoredKey: public_key });
        enc_options.encryptionKeys = pk_array
    }
    else {
        console.log("neither pass nor key. Cannot encrypt.")
        return update_armoured_text("")
    }

    openpgp.config.preferredCompressionAlgorithm = openpgp.enums.compression.zlib

    const encrypted_text = await openpgp.encrypt(enc_options);

    return encrypted_text.replace("-----BEGIN PGP MESSAGE-----\n",
        "-----BEGIN PGP MESSAGE-----\nVersion: opengpg.js ( " + BASEURL.www + " )\n");

}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export async function decrypt_gpg(rcv_message, quiet) {

    try {

        const encryptedMessage = await openpgp.readMessage({ armoredMessage: rcv_message.armoured_text });

        var is_asymmertic_encryption = null;

        var decrypted;

        if (rcv_message.secret_PSK) {
            // symmetric PSK crypto
            is_asymmertic_encryption = false;
            const { data: decrypted_psk } = await openpgp.decrypt({
                message: encryptedMessage,
                passwords: [rcv_message.secret_PSK], // decrypt with password
                //format: 'binary' // output as Uint8Array
            })
            decrypted = decrypted_psk
        } else {
            // PKI crypto            
            const keyPair = await db_PrivateKeyPair.get("keyPair")

            const privateKey = await openpgp.decryptKey({
                privateKey: await openpgp.readPrivateKey({ armoredKey: keyPair.privateKey }),
                passphrase: keyPair.passphrase
            })

            const publicKey = await openpgp.readKey({ armoredKey: rcv_message.pgp_pubkey });

            const { data: decrypted_privk, signatures } = await openpgp.decrypt({
                message: encryptedMessage,
                decryptionKeys: privateKey,
                expectSigned: true,
                verificationKeys: publicKey // mandatory with expectSigned=true
            })

            decrypted = decrypted_privk

            if (await signatures[0].verified === true)
                is_asymmertic_encryption = true;

        }

    } catch (err) {
        if (quiet !== true)
            console.log(err)
        return {
            success: false,
            error: err.message
        }
    }

    return {
        success: true,
        message: decrypted,
        is_asymmertic_encryption
    }

    /*
    try {
        const encryptedMessage = await openpgp.readMessage({ armoredMessage: rcv_message.armoured_text });

        const getEncryptionKeyIDs = encryptedMessage.getEncryptionKeyIDs()
        const recipientKeyId = JSON.stringify(getEncryptionKeyIDs[0])

        const myPubEncryptionKeyIDs = await getMyPubKeyID()

        var decrypted = null

        if (recipientKeyId && myPubEncryptionKeyIDs != recipientKeyId) {
            const error = "PUBKEY_NOT_FOR_THIS_RCPT";
            console.log(error);
            return {
                success: false,
                error
            }
        }

        if (!myPubEncryptionKeyIDs && !rcv_message.secret_PSK) {
            const error = "NEITHER_PKI_NOR_PSK";
            console.log(error);
            return {
                success: false,
                error
            }

        }

        var is_asymmertic_encryption = null;

        if (myPubEncryptionKeyIDs == recipientKeyId && myPubEncryptionKeyIDs != null) {

            // PKI crypto            
            const keyPair = await db_PrivateKeyPair.get("keyPair")

            const privateKey = await openpgp.decryptKey({
                privateKey: await openpgp.readPrivateKey({ armoredKey: keyPair.privateKey }),
                passphrase: keyPair.passphrase
            })

            const publicKey = await openpgp.readKey({ armoredKey: rcv_message.pgp_pubkey });

            const { data: decrypted_privk, signatures } = await openpgp.decrypt({
                message: encryptedMessage,
                decryptionKeys: privateKey,
                expectSigned: true,
                verificationKeys: publicKey // mandatory with expectSigned=true
            })

            decrypted = decrypted_privk

            if (await signatures[0].verified === true)
                is_asymmertic_encryption = true;

        } else {
            // symmetric PSK crypto
            is_asymmertic_encryption = false;
            const { data: decrypted_psk } = await openpgp.decrypt({
                message: encryptedMessage,
                passwords: [rcv_message.secret_PSK], // decrypt with password
                //format: 'binary' // output as Uint8Array
            })
            decrypted = decrypted_psk
        }

        if (decrypted.length < 1) {
            alert("Unexpected error: The decrypt_error is null and decrypted.length < 1")
            return
        }
    } catch (err) {
        console.log(err)
        return {
            success: false,
            error: err.message
        }
    }

    // verify signature

    return {
        success: true,
        message: decrypted,
        is_asymmertic_encryption
    }
 */
}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export const sign_gpg = async (plain_text) => {

    const keyPair = await db_PrivateKeyPair.get('keyPair');

    if (keyPair == null)
        return null
    /*
    const decryptedPrivKey = await openpgp.decryptKey({
        privateKey: await openpgp.readPrivateKey({ armoredKey: keyPair.privateKey }),
        passphrase: keyPair.passphrase
    })
    */

    //const publicKey = await openpgp.readKey({ armoredKey: keyPair.privateKey });

    const privateKey = await openpgp.decryptKey({
        privateKey: await openpgp.readPrivateKey({ armoredKey: keyPair.privateKey }),
        passphrase: keyPair.passphrase
    });

    const unsignedMessage = await openpgp.createCleartextMessage({ text: plain_text });
    const cleartextMessage = await openpgp.sign({
        message: unsignedMessage, // CleartextMessage or Message object
        signingKeys: privateKey
    });

    return cleartextMessage; // '-----BEGIN PGP SIGNED MESSAGE ... END PGP SIGNATURE-----'

}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
async function getMyPubKeyID() {

    try {
        const keyPair = await db_PrivateKeyPair.get('keyPair');

        if (keyPair == null)
            return null;

        const message = await openpgp.createMessage({ text: "Dummy text" });

        const encryptionKeys = await openpgp.readKey({ armoredKey: keyPair.publicKey });

        openpgp.config.preferredCompressionAlgorithm = openpgp.enums.compression.zlib

        const encrypted_armoured = await openpgp.encrypt({ message, encryptionKeys });

        const encryptedMessage_dummy = await openpgp.readMessage({ armoredMessage: encrypted_armoured });

        return JSON.stringify(encryptedMessage_dummy.getEncryptionKeyIDs()[0])
    } catch (err) {
        console.log(err)
        return null;
    }

}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export const get_pub_key = async (pubk) => {

    var str_pubkey;

    if (pubk)
        str_pubkey = pubk
    else {
        // get pubkey from storage
        const keyPair = await db_PrivateKeyPair.get('keyPair');
        if (keyPair == null) {
            console.log("No keyPair found.")
            return null;
        }
        str_pubkey = keyPair.publicKey
    }

    const publicKey = await openpgp.readKey({ armoredKey: str_pubkey })

    const myKeyPairUserID = publicKey.getUserIDs()
    const myKeyPairKeyID = publicKey.getKeyID().toHex()
    const myKeyPairFingerprint = publicKey.getFingerprint()
    const myKeyPairPublicKey = str_pubkey

    return { myKeyPairUserID, myKeyPairKeyID, myKeyPairFingerprint, myKeyPairPublicKey }

}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
export const is_my_pubkey = async (fingerprint, pubk_array) => {

    for (const i in pubk_array) {
        const pubk = await get_pub_key(pubk_array[i]);
        if (pubk.myKeyPairFingerprint == fingerprint)
            return true
    }
    return false
}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export const pubkey_exists = async (pubk) => {

    for (const key_id of await db_ExtPub.keys()) {
        const key = await db_ExtPub.get(key_id)
        if (key.publicKey === pubk)
            return true;
    }
    return false;

}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export async function add_pub_key(pubk) {

    const publicKey = await openpgp.readKey({ armoredKey: pubk });
    const keyPairUserID = publicKey.getUserIDs()
    const keyPairKeyID = publicKey.getKeyID().toHex()
    const keyPairFingerprint = publicKey.getFingerprint()

    const obj_ext_pub = {
        keyID: keyPairKeyID,
        userID: keyPairUserID,
        fingerprint: keyPairFingerprint,
        publicKey: pubk,
        date: (new Date()).toISOString()
    }

    await db_ExtPub.set(keyPairFingerprint, obj_ext_pub);

    return obj_ext_pub;

}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export async function list_pub_keys() {

    const ret = []

    const keys = await db_ExtPub.keys();

    for (const key_id of keys) {
        const key = await db_ExtPub.get(key_id);
        ret.push({
            publicKey: key.publicKey,
            userID: key.userID,
            keyID: key.keyID,
            KeyPairFingerprint: key.fingerprint
        })
    }

    const sorted_ret = ret.sort((a, b) => {
        const A = a.userID[0].toLowerCase();
        const B = b.userID[0].toLowerCase();
        return A.localeCompare(B);
    });

    return sorted_ret;

}

// ----------------------------------------------------------------------------------
export async function gpg_import_keypair(privateKeyArmored, publicKeyArmored, passphrase) {

    const keypair = await veirfy_keypair(privateKeyArmored, publicKeyArmored, passphrase);

    await db_PrivateKeyPair.set("keyPair", keypair);

    const mykey = await get_pub_key();

    await add_pub_key(mykey.myKeyPairPublicKey);

}
// ----------------------------------------------------------------------------------

async function veirfy_keypair(privateKeyArmored, publicKeyArmored, passphrase) {

    // privateKeyArmored =  `-----BEGIN PGP PUBLIC KEY BLOCK-----
    // publicKeyArmored  =  `-----BEGIN PGP PRIVATE KEY BLOCK-----
    // passphrase        = What the private key is encrypted with

    const publicKey = await openpgp.readKey({ armoredKey: publicKeyArmored });

    const privateKey = await openpgp.decryptKey({
        privateKey: await openpgp.readPrivateKey({ armoredKey: privateKeyArmored }),
        passphrase
    });

    const encrypted = await openpgp.encrypt({
        message: await openpgp.createMessage({ text: 'Hello, World!' }), // input as Message object
        encryptionKeys: publicKey,
        signingKeys: privateKey // optional
    });

    const message = await openpgp.readMessage({
        armoredMessage: encrypted // parse armored message
    });
    const { data: decrypted, signatures } = await openpgp.decrypt({
        message,
        verificationKeys: publicKey, // optional
        decryptionKeys: privateKey
    });

    await signatures[0].verified; // throws on invalid signature

    return {
        passphrase: passphrase,
        privateKey: privateKeyArmored,
        publicKey: publicKeyArmored
    }
}
// ----------------------------------------------------------------------------------

export function generateSecureString(length = 20) {
    const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    // Create an array of unsigned 32-bit integers
    const randomValues = new Uint32Array(length);
    crypto.getRandomValues(randomValues);

    for (let i = 0; i < length; i++) {
        // Use the modulo operator to pick a character from our set
        result += charset[randomValues[i] % charset.length];
    }

    return result;
};